<mat-sidenav-container autosize>
  <mat-sidenav
    [class.mobile]="rwdService.isSmallDevice"
    id="sidenav"
    [mode]="rwdService.isSmallDevice ? 'over' : 'side'"
    [opened]="rwdService.navPanelOpened"
    (closedStart)="rwdService.closeNavPanel()"
    [fixedInViewport]="true"
  >
    <app-navigation [contextType]="contextType"></app-navigation>
  </mat-sidenav>
  <mat-sidenav-content [class.mobile]="rwdService.isSmallDevice">
    <div class="top-bar">
      <app-top-bar [contextData]="contextData"></app-top-bar>
    </div>
    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
